import axiosAPI, { setNewHeaders } from "./axiosApi";

export async function obtainToken(username, password) {
  const response = await axiosAPI.post("token/obtain/", {
    username,
    password,
  });
  // console.log(document.cookie);
  const cookieValue = document.cookie.split("; ")
  .find(row=>row.startsWith("csrftoken="))?.split("=")[1];
  await fetch(
    '/admin/login/',{
      method:'POST',
      headers:{
        'Content-Type':'application/x-www-form-urlencoded',
      },
      redirect: "manual",
      body:"username="+username+"&password="+password+"&csrfmiddlewaretoken="+cookieValue
    }
  )
  setNewHeaders(response);
  return response;
}

export async function refreshToken(refresh) {
  const response = await axiosAPI.post("token/refresh/", {
    refresh,
  });
  setNewHeaders(response);
  return response;
}

// eslint-disable-next-line
export async function logout(accessToken) {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  // TODO: invalidate token on backend
}

export const isAuthenticated = () => {
  const token = localStorage.getItem("access_token");
  return !!token;
};

export const isAdmin = () => {
  const token = localStorage.getItem("access_token");
  return !!token;
};
